
export const formatNumberBig = (amount) => {
    amount = "" + Math.round(amount);
    let ret = "";
    for (let i = 0; i < amount.length; i++) {
        if (i > 0 && i % 3 === 0) {
            ret = "," + ret;
        }
        ret = amount[amount.length - 1 - i] + ret;
    }
    return ret;
};